import Helpers from '../Config/Helpers';

function Register(){
    return (
        <div className="auth-page-wrapper pt-5">
        <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
            <div className="bg-overlay"></div>
        </div>

        <div className="auth-page-content">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="text-center mt-sm-5 mb-4 text-white-50">
                            <div>
                                <a href="index.html" className="d-inline-block auth-logo">
                                    <img src={require('../images/logo-light.png')} alt="" height="20" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-5">
                        <div className="card mt-4">

                            <div className="card-body p-4">
                                <div className="text-center mt-2">
                                    <h5 className="text-primary">Welcome Back !</h5>
                                    <p className="text-muted">Sign in to continue to { Helpers.appName }.</p>
                                </div>
                                <div className="p-2 mt-4">
                                    <form action="https://themesbrand.com/velzon/html/material/index.html">

                                        <div className="mb-3">
                                            <label htmlFor="username" className="form-label">Username</label>
                                            <input type="text" className="form-control" id="username" placeholder="Enter username" />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="username" className="form-label">Email</label>
                                            <input type="text" className="form-control" id="username" placeholder="Enter username" />
                                        </div>

                                        <div className="mb-3">
                                            <div className="float-end">
                                                <a href="auth-pass-reset-basic.html" className="text-muted">Forgot password?</a>
                                            </div>
                                            <label className="form-label" htmlFor="password-input">Password</label>
                                            <div className="position-relative auth-pass-inputgroup mb-3">
                                                <input type="password" className="form-control pe-5 password-input" placeholder="Enter password" id="password-input" />
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <button className="btn btn-success w-100" type="submit">Sign In</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="text-center">
                            <p className="mb-0 text-muted">
                                &copy; { Helpers.appName }. Created By <a href="https://cyberify.co">Cyberify</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
    );
}

export default Register;